export function IntroductionSection() {
  return (
    <section id="introduction" className="space-y-1">
      <h3 className="text-lg leading-6 font-bold -tracking-wide text-neutral-950">
        Introduction
      </h3>
      <p className="text-sm leading-[140%] font-medium text-neutral-950">
        Your use of the Metawhale Platform (the "Platform") provided by
        Metawhale ("the Owner") and the services provided constitute your
        agreement to be bound by these Terms of Service.
        <br /> <br />
        By accessing and placing an order with the Platform, you confirm that
        you agree with and are bound by the terms of service outlined in the
        Terms & Conditions below. These terms apply to the entire platform and
        any email or other type of communication between you and the Platform.
        <br /> <br />
        Under no circumstances shall the Owner be liable for any direct,
        indirect, special, incidental, or consequential damages, including but
        not limited to, loss of data or profit, arising out of the use or
        inability to use the materials on this site, even if the Owner or an
        authorized representative has been advised of the possibility of such
        damages. If your use of materials from this site results in the need for
        servicing, repair, or correction of equipment or data, you assume any
        costs thereof.
        <br /> <br />
        The Platform and the Owner shall not be responsible for any outcome that
        may occur during the course of usage of our resources. We reserve the
        right to change prices and revise the resources usage policy at any
        time.
      </p>
    </section>
  );
}

export function DefinitionsSection() {
  return (
    <section id="definitions" className="space-y-5">
      <div className="space-y-1">
        <h3 className="text-lg leading-6 font-bold -tracking-wide text-neutral-950">
          Definitions
        </h3>
        <div className="space-y-4">
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            <span className="font-bold">"Account" </span> refers to a unique
            account created for the User to access the Platform or parts of the
            Platform.
          </p>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            <span className="font-bold">"Platform" </span> refers to the
            Metawhale web application, including its subdomains, mobile apps,
            and any other platforms through which the Owner provides the
            Service. The Service includes the Platform, related software,
            content, and documentation.
          </p>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            <span className="font-bold">"Content" </span> refers to any text,
            images, videos, audio, or other multimedia content, information, or
            material submitted, posted, or displayed on or through the Platform.
          </p>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            <span className="font-bold">"Media Monitoring Data" </span>
            refers to publicly available media content from Print, Online, TV,
            Radio, and Social Media sources that is collected, processed, and
            displayed through the Platform.
          </p>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            <span className="font-bold">"Cookie" </span>
            refers to a small amount of data generated by the platform and saved
            by your web browser.
          </p>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            <span className="font-bold">"Device" </span>
            refers to any internet-connected device such as a phone, tablet,
            computer, or any other device that can be used to access the
            Metawhale Platform and use the services.
          </p>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            <span className="font-bold">
              "Intellectual Property Rights" &nbsp;
            </span>
            includes trade names, domain names, copyrights, moral rights, rights
            in designs, rights in computer software, database rights, rights in
            confidential information (including know-how and trade secrets), and
            any other intellectual property rights.
          </p>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            <span className="font-bold">"License" </span>
            refers to the non-exclusive, non-transferable, revocable right to
            use the Platform as granted by the Owner to the User.
          </p>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            <span className="font-bold">"Owner" </span>
            refers to Metawhale, the provider of the Platform.
          </p>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            <span className="font-bold">"Personal Data" </span>
            refers to any information that relates to an identified or
            identifiable individual, including but not limited to names,
            addresses, email addresses and phone numbers.
          </p>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            <span className="font-bold">"Privacy Policy" </span>
            refers to the policy regarding the collection, use, and storage of
            personal data, which is available at metawhale-privacy-policy.html.
          </p>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            <span className="font-bold">"Terms" </span>
            refers to these Terms of Service, including any updates,
            modifications, or supplements.
          </p>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            <span className="font-bold">"Third-Party Services" </span>
            refers to any services or content provided by third parties that may
            be linked to or accessible through the Platform, including social
            media APIs and media data providers.
          </p>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            <span className="font-bold">"User or You" </span>
            refers to any individual or entity that is registered with the
            Metawhale Platform to use the services.
          </p>
        </div>
      </div>
    </section>
  );
}

export function LicenseSection() {
  return (
    <section id="license" className="space-y-5">
      <div className="space-y-1">
        <h3 className="text-lg leading-6 font-bold -tracking-wide text-neutral-950">
          License
        </h3>
        <div className="space-y-4">
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            The Platform provides the User with a revocable, non-exclusive,
            non-transferable, limited license to access and use the platform for
            media monitoring purposes, as outlined in this Terms of Service.
          </p>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            This establishes a legal agreement between the Owner and the User.
            This agreement governs your use of the Platform and the associated
            Services.
          </p>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            By accessing and using the Platform, you agree to comply with these
            Terms of Service. If you disagree with any part of these terms, you
            should not use the Platform.
          </p>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            In the event of any violation of these Terms & Conditions, the Owner
            reserves the right to suspend or terminate your account and block
            access without notice.
          </p>
        </div>
      </div>
    </section>
  );
}

export function PlatformEligibilitySection() {
  return (
    <section id="platform-eligibility" className="space-y-5">
      <h3 className="text-lg leading-6 font-bold -tracking-wide text-neutral-950">
        Platform Eligibility Statement
      </h3>

      <section className="space-y-6 pl-4">
        <div className="space-y-1">
          <h1
            id="eligibility"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Eligibility
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            The Platform is intended for business users and professionals who
            are at least eighteen (18) years of age. By accessing or using the
            Platform, you confirm that you meet this age requirement and have
            the authority to enter into this agreement on behalf of yourself or
            your organization.
          </p>
        </div>
        <div className="space-y-1">
          <h1
            id="registration-info"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Registration Information
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            Users must provide accurate and complete registration information
            when you sign-up for an account. This information is essential for
            maintaining the integrity and security of the Platform. You agree
            to:
          </p>
          <ul className="list-disc pt-3 pl-8 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Accuracy: &nbsp;
              </span>
              Ensure that all information provided during the registration is
              truthful, accurate, and up-to-date.
            </li>
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Updates: &nbsp;
              </span>
              Promptly update any changes to your registration information to
              keep it current and accurate.
            </li>
          </ul>
        </div>
        <div className="space-y-1">
          <h1
            id="account-security"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Account Security
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            Maintaining the security of your account is your responsibility.
            Users agree to:
          </p>
          <ul className="list-disc py-3 pl-8 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Password Protection: &nbsp;
              </span>
              Keep your account password and API keys confidential and do not
              share them with others.
            </li>
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Unauthorized Access: &nbsp;
              </span>
              Notify the Platform provider immediately if you suspect any
              unauthorized access or use of your account.
            </li>
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Account Activity: &nbsp;
              </span>
              You are responsible for all activities that occur under your
              account, including API usage.
            </li>
          </ul>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            By registering and using the Platform, you acknowledge and accept
            these requirements and responsibilities.
          </p>
        </div>
      </section>
    </section>
  );
}

export function AcceptableUsePolicySection() {
  return (
    <section id="acceptable-use" className="space-y-5">
      <h3 className="text-lg leading-6 font-bold -tracking-wide text-neutral-950">
        Acceptable Use Policy
      </h3>

      <section className="space-y-6 pl-4">
        <div className="space-y-1">
          <h1
            id="respect-conduct"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Respect and Conduct
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            Users are expected to respect others and adhere to the following
            guidelines:
          </p>
          <ul className="list-disc py-3 pl-8 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Prohibited Content: &nbsp;
              </span>
              Users must refrain from using the Platform to monitor, collect, or
              distribute any content that is illegal, offensive, harmful or
              otherwise inappropriate. This includes but is not limited to:
            </li>
            <ul className="list-disc pl-8 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
              <li>Hate speech or discriminatory content</li>
              <li>Harassment, bullying, or abusive behavior</li>
              <li>
                Content that infringes on the rights of others, including
                intellectual property rights
              </li>
              <li>
                Using monitoring data for illegal surveillance or stalking
              </li>
            </ul>
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Impersonation: &nbsp;
              </span>
              Users must not impersonate any person or entity.
            </li>
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Automated Abuse: &nbsp;
              </span>
              The use of automated systems or software to abuse API rate limits,
              overload systems, or manipulate the Platform is strictly
              prohibited.
            </li>
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Data Reselling: &nbsp;
              </span>
              Users may not resell, redistribute, or sublicense monitoring data
              obtained through the Platform without explicit written permission.
            </li>
          </ul>
        </div>
        <div className="space-y-1">
          <h1
            id="security-integrity"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Security and Integrity
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            To maintain the security and integrity of the Platform:
          </p>
          <ul className="list-disc py-3 pl-8 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Unauthorized Use: &nbsp;
              </span>
              Unauthorized use of the Platform is prohibited. This includes but
              is not limited to:
            </li>
            <ul className="list-disc pl-8 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
              <li>
                Decompiling, reverse engineering, or disassembling the Platform
              </li>
              <li>
                Renting, leasing, loaning, selling, sublicensing, or creating
                derivative works from the Platform or its Content
              </li>
              <li>
                Attempting to gain unauthorized access to any portion of the
                Platform or its related systems
              </li>
            </ul>
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Account Suspension: &nbsp;
              </span>
              The Owner reserves the right to suspend or terminate accounts that
              violate these terms. This includes actions that compromise the
              security, integrity, or functionality of the Platform.
            </li>
          </ul>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            By using this Platform, you agree to adhere to these guidelines.
            Failure to comply may result in suspension or termination of your
            account and access to the Platform.
          </p>
        </div>
      </section>
    </section>
  );
}

export function PrivacyDataProtectionSection() {
  return (
    <section id="privacy-data-protection" className="space-y-5">
      <div className="space-y-1">
        <h3 className="text-lg leading-6 font-bold -tracking-wide text-neutral-950">
          Privacy and Data Protection
        </h3>
        <p className="text-sm leading-[140%] font-medium text-neutral-950">
          The Owner is committed to protecting User privacy in compliance with
          global data protection laws, including the Philippine Data Privacy Act
          of 2012 and GDPR. The Privacy Policy provides detailed information on
          how your data is collected, used, and protected. However, while we
          strive to use commercially acceptable means to protect your data,
          absolute security cannot be guaranteed.
        </p>
      </div>
      <section className="space-y-6 pl-4">
        <div className="space-y-1">
          <h1
            id="commitment-to-privacy"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Commitment to Privacy
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            Users are expected to respect others and adhere to the following
            guidelines:
          </p>
          <ul className="list-disc pt-3 pl-8 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Compliance: &nbsp;
              </span>
              The Owner adheres to international standards and regulations
              regarding data protection, including but not limited to GDPR, the
              Philippine Data Privacy Act, and other relevant laws.
            </li>
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Transparency: &nbsp;
              </span>
              Detailed information on data collection, usage, and protection
              measures can be found in the Privacy Policy.
            </li>
          </ul>
        </div>
        <div className="space-y-1">
          <h1
            id="data-security"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Data Security
          </h1>
          <ul className="list-disc py-3 pl-8 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Security Measures: &nbsp;
              </span>
              We implement robust security measures to protect your data from
              unauthorized access, alteration, disclosure, or destruction. These
              measures include encryption, firewalls, and secure access
              protocols.
            </li>
            <li>
              <span className="text-sm leading-[140%] font-bold tracking-normal text-neutral-950">
                Limitations: &nbsp;
              </span>
              Despite our efforts to protect your data, we cannot guarantee its
              absolute security due to the inherent risks associated with data
              transmission over the internet and electronic storage systems.
            </li>
          </ul>
        </div>
      </section>
      <p className="text-sm leading-[140%] font-medium text-neutral-950">
        By using this Platform, you acknowledge and accept the practices
        described in the Privacy Policy and the inherent risks associated with
        data security.
      </p>
    </section>
  );
}

export function IntellectualPropertySection() {
  return (
    <section id="intellectual-property" className="space-y-5">
      <div className="space-y-1">
        <h3 className="text-lg leading-6 font-bold -tracking-wide text-neutral-950">
          Intellectual Property
        </h3>
      </div>
      <section className="space-y-6 pl-4">
        <div className="space-y-1">
          <h1
            id="ownership"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Ownership of Metawhale IP
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            The Metawhale Platform, including all related software, algorithms,
            databases, user interfaces, content, and branding elements, are the
            exclusive property of Metawhale (the "Owner") or its licensors. All
            copyrights, trademarks, patents, and other intellectual property
            rights in the Metawhale Platform are reserved by the Owner.
          </p>
        </div>
        <div className="space-y-1">
          <h1
            id="user-content"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            User Content
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            Users retain ownership of any content they create and upload to the
            Metawhale Platform, such as monitoring configurations, saved
            searches, and custom reports. However, by using the Platform, Users
            grant the Owner a non-exclusive license to store, process, and
            display that User content within the Metawhale Service as necessary
            to provide the services.
          </p>
        </div>
        <div className="space-y-1">
          <h1
            id="restrictions"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Restrictions on Use
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            Users are prohibited from:
          </p>
          <ul className="list-disc pt-3 pl-8 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
            <li>
              Reverse-engineering, decompiling, or attempting to access the
              source code of the Platform
            </li>
            <li>
              Copying, modifying, or creating derivative works based on the
              Platform
            </li>
            <li>
              Removing, altering, or obscuring any copyright or other
              proprietary notices from the Platform
            </li>
            <li>
              Using the Platform for any unlawful purpose or in any way that
              could harm the Platform or its users
            </li>
            <li>
              License, sell, rent, lease, assign, distribute, transmit, host,
              outsource, disclose, or otherwise commercially exploit the
              platform or make the platform available to any third party
            </li>
          </ul>
        </div>
        <div className="space-y-1">
          <h1
            id="media-content"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Media Content
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            Media content monitored and displayed through the Platform (news
            articles, social media posts, broadcast transcripts, etc.) remains
            the intellectual property of its original creators and publishers.
            Metawhale provides access to this content for monitoring and
            analysis purposes only. Users must comply with all applicable
            copyright laws when using monitored content.
          </p>
        </div>
        <div className="space-y-1">
          <h1
            id="feedback"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Feedback
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            Any suggestions or ideas provided by Users for improving the
            Metawhale Platform ("Feedback") will be deemed non-confidential. The
            Owner acquires a perpetual, irrevocable right to use, develop, and
            exploit such Feedback without any compensation or credit to the
            User.
          </p>
        </div>
        <div className="space-y-1">
          <h1
            id="termination-of-rights"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Termination of Rights
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            The Owner reserves the right to terminate or suspend access to the
            Platform for Users who violate these Intellectual Property terms.
          </p>
        </div>
      </section>
    </section>
  );
}

export function ServiceAvailabilitySection() {
  return (
    <section id="service-availability" className="space-y-5">
      <div className="space-y-1">
        <h3 className="text-lg leading-6 font-bold -tracking-wide text-neutral-950">
          Service Availability and Functionality
        </h3>
        <p className="text-sm leading-[140%] font-medium text-neutral-950">
          The Owner strives to provide reliable and consistent service to its
          Users. However, there are inherent limitations and factors that can
          affect service availability and functionality.
        </p>
      </div>
      <section className="space-y-6 pl-4">
        <div className="space-y-1">
          <h1
            id="service-uptime"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Service Uptime
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            The Owner aims for a monthly uptime of 99.9%. Despite this goal,
            uninterrupted service cannot be guaranteed due to various potential
            disruptions including but not limited to:
          </p>
          <ul className="list-disc pt-3 pl-8 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
            <li>Scheduled maintenance</li>
            <li>Unforeseen technical issues</li>
            <li>Third-party API limitations or outages</li>
            <li>Force majeure events</li>
          </ul>
        </div>
        <div className="space-y-1">
          <h1
            id="media-coverage-variations"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Media Coverage Variations
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            Media monitoring coverage and availability may vary based on:
          </p>
          <ul className="list-disc pt-3 pl-8 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
            <li>Source availability and accessibility</li>
            <li>Third-party API limitations</li>
            <li>Regional media landscape changes</li>
            <li>Technical constraints of broadcast transcription</li>
          </ul>
        </div>
        <div className="space-y-1">
          <h1
            id="disclaimer-of-warranties"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Disclaimer of Warranties
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            The Owner does not warrant that the service will meet the User's
            specific requirements, be uninterrupted, timely, secure, or
            error-free. The Owner disclaims any liability for any loss or damage
            resulting from service interruptions, temporary unavailability, or
            changes in functionality.
          </p>
        </div>
        <div className="space-y-1">
          <h1
            id="support-and-maintenance"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Support and Maintenance
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            The Owner will endeavor to provide timely support and maintenance to
            address any issues affecting service availability and functionality.
            Users are encouraged to report any disruptions or issues to the
            support team for prompt resolution.
          </p>
        </div>
      </section>
    </section>
  );
}

export function ModificationOfTermsSection() {
  return (
    <section id="modification-of-terms" className="space-y-5">
      <div className="space-y-1">
        <h3 className="text-lg leading-6 font-bold -tracking-wide text-neutral-950">
          Modification of Terms
        </h3>
        <p className="text-sm leading-[140%] font-medium text-neutral-950">
          The Owner reserves the right to update these Terms at any time. Such
          changes will be posted on the Platform, and Users are encouraged to
          review the Terms regularly. Continued use of the Platform after any
          such modifications indicates acceptance of the new terms.
        </p>
      </div>
      <section className="space-y-6 pl-4">
        <div className="space-y-1">
          <h1
            id="notification-of-changes"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Notification of Changes
          </h1>
          <ul className="list-disc pt-3 pl-8 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
            <li>
              All changes to the Terms will be posted on the Platform's website
            </li>
            <li>
              Updates will become effective immediately upon posting unless
              otherwise specified
            </li>
          </ul>
        </div>
        <div className="space-y-1">
          <h1
            id="user-consent"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            User Consent
          </h1>
          <ul className="list-disc pt-3 pl-8 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
            <li>
              Continued use of the Platform following the posting of changes
              constitutes your acceptance of those changes
            </li>
            <li>
              If you do not agree with the modified terms, you must discontinue
              use of the Platform immediately
            </li>
          </ul>
        </div>
        <div className="space-y-1">
          <h1
            id="significant-changes"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Significant Changes
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            For any significant changes that may affect your rights or
            obligations, the Owner will provide advance notice (such as an email
            notification or a prominent notice on the Platform interface).
          </p>
        </div>
      </section>
    </section>
  );
}

export function GoverningLawSection() {
  return (
    <section id="governing-law" className="space-y-5">
      <div className="space-y-1">
        <h3 className="text-lg leading-6 font-bold -tracking-wide text-neutral-950">
          Governing Law and Dispute Resolution
        </h3>
        <p className="text-sm leading-[140%] font-medium text-neutral-950">
          These Terms are governed by the laws of the Republic of the
          Philippines. Any disputes should first be resolved through good-faith
          negotiation or mediation. If unresolved, disputes may be brought
          before the courts of competent jurisdiction in the Philippines.
          <br />
          <br />
          The Owner reserves the right to seek injunctive or other equitable
          relief in any competent jurisdiction to protect its intellectual
          property or confidential information.
        </p>
      </div>
    </section>
  );
}

export function TerminationSection() {
  return (
    <section id="termination" className="space-y-5">
      <div className="space-y-1">
        <h3 className="text-lg leading-6 font-bold -tracking-wide text-neutral-950">
          Termination
        </h3>
        <p className="text-sm leading-[140%] font-medium text-neutral-950">
          Either party may terminate this agreement at any time. Upon
          termination:
        </p>
      </div>
      <section className="space-y-6 pl-4">
        <div className="space-y-1">
          <ul className="list-disc pl-8 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
            <li>
              The User's account and access to the Platform will be revoked
              immediately
            </li>
            <li>
              Monitoring data and configurations may be permanently deleted
              after a grace period
            </li>
            <li>Any outstanding fees remain due and payable</li>
            <li>API keys will be deactivated</li>
          </ul>
        </div>
      </section>
      <p className="text-sm leading-[140%] font-medium text-neutral-950">
        The Owner may terminate or suspend access immediately, without prior
        notice or liability, for any reason whatsoever, including without
        limitation if you breach the Terms.
      </p>
    </section>
  );
}

export function LimitationOfLiabilitySection() {
  return (
    <section id="limitation-of-liability" className="space-y-5">
      <div className="space-y-1">
        <h3 className="text-lg leading-6 font-bold -tracking-wide text-neutral-950">
          Limitation of Liability
        </h3>
      </div>
      <section className="space-y-6 pl-4">
        <div className="space-y-1">
          <h1
            id="scope-and-cap-of-liability"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Scope and Cap of Liability
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            The Owner's liability for any claims arising from or related to the
            use of the Service is limited to the amount the User paid for the
            specific services in the twelve (12) months immediately preceding
            the event giving rise to the claim.
          </p>
        </div>
        <div className="space-y-1">
          <h1
            id="legal-constraints"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Legal Constraints
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            The limitations of liability outlined herein will be enforced to the
            extent permitted by applicable laws and regulations.
          </p>
        </div>
        <div className="space-y-1">
          <h1
            id="service-disclaimer"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Service Disclaimer
          </h1>

          <ul className="list-disc py-3 pl-8 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
            <li>
              The Service is provided on an "as is" and "as available" basis
              without any warranties of any kind
            </li>
            <li>
              The Owner makes no representations or warranties regarding the
              reliability, availability, accuracy, quality, suitability, or
              completeness of the Service or monitored media data
            </li>
            <li>
              The Owner does not guarantee the Service will meet the User's
              expectations or be free from errors
            </li>
            <li>
              Users assume all risks associated with the use of the Service
            </li>
          </ul>
        </div>
        <div className="space-y-1">
          <h1
            id="acknowledgment-and-severability"
            className="text-[18px] leading-5 font-bold -tracking-wide text-neutral-950"
          >
            Acknowledgment and Severability
          </h1>
          <p className="text-sm leading-[140%] font-medium text-neutral-950">
            Users acknowledge and agree to the limitations of liability as
            outlined in these Terms. If any provision of this clause is found to
            be invalid or unenforceable, the remaining provisions will continue
            in full force and effect.
          </p>
        </div>
      </section>
    </section>
  );
}

export function IndemnificationSection() {
  return (
    <section id="indemnification" className="space-y-5">
      <div className="space-y-1">
        <h3 className="text-lg leading-6 font-bold -tracking-wide text-neutral-950">
          Indemnification
        </h3>
        <p className="text-sm leading-[140%] font-medium text-neutral-950">
          Users agree to indemnify, defend and hold harmless the Owner and its
          affiliates from any claims, losses, liabilities, damages, expenses
          related to:
        </p>
      </div>
      <div className="space-y-1">
        <ul className="list-disc pl-8 text-sm leading-[140%] font-medium tracking-normal text-neutral-950">
          <li>Violation of Terms, third-party rights, or applicable laws</li>
          <li>User contributions and activities on the Platform</li>
          <li>Breach of representations and warranties made by the User</li>
          <li>Intellectual property rights violations</li>
          <li>Breaches of data privacy laws or regulations</li>
          <li>Misuse of monitoring data or API access</li>
          <li>Harmful actions or conduct towards other Users</li>
        </ul>
      </div>
      <p className="text-sm leading-[140%] font-medium text-neutral-950">
        The User must promptly notify the Owner of any such claims, cooperate
        fully in the defense, and cover all associated expenses. The Owner
        reserves the right to assume exclusive control of the defense or
        settlement of any claim.
      </p>
    </section>
  );
}

export function DisclaimerSection() {
  return (
    <section id="disclaimer" className="space-y-5">
      <div className="space-y-1">
        <h3 className="text-lg leading-6 font-bold -tracking-wide text-neutral-950">
          Disclaimer
        </h3>
        <p className="text-sm leading-[140%] font-medium text-neutral-950">
          The Platform and the Owner is not responsible for any content, code,
          or inaccuracies provided through its services. The Platform makes no
          warranties or guarantees of any kind.
          <br />
          <br />
          In no event shall the Platform be liable for any special, direct,
          indirect, consequential, or incidental damages, or any damages
          whatsoever, whether in an action of contract, negligence, or other
          tort, arising out of or in connection with the use of the Service or
          the contents of the Service.
          <br />
          <br />
          The Platform and its content are provided on an "as is" and "as
          available" basis without any warranties or representations of any
          kind, either express or implied. The Platform acts as an aggregator of
          publicly available media content and exercises no editorial control
          over such content, making no warranty or representation regarding the
          accuracy, reliability, or currency of any information, content,
          service, or merchandise provided through or accessible via the
          Platform.
          <br />
          <br />
          Without limiting the foregoing, the Platform specifically disclaims
          all warranties and representations in any content transmitted through
          or in connection with the Platform, including without limitation any
          warranties of merchantability, fitness for a particular purpose, or
          non-infringement of third-party rights.
        </p>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="space-y-5">
      <div className="space-y-1">
        <h3 className="text-lg leading-6 font-bold -tracking-wide text-neutral-950">
          Contact
        </h3>
        <p className="text-sm leading-[140%] font-medium text-neutral-950">
          For any questions or concerns, please reach out to the Owner at{" "}
          <a href="mailto:info@metawhale.com" className="underline">
            info@metawhale.com
          </a>
          .
        </p>
      </div>
    </section>
  );
}
